import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/global.css";
import "./assets/fonts/iconfont.css";
import TreeTable from "vue-table-with-tree-grid";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "nprogress/nprogress.css";
import store from "./store/index";
import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i18n'
import VDistpicker from "v-distpicker";
import lodash from "lodash";
//引入过滤器
import "./assets/js/filter.js";
//引入axios请求
import "./assets/js/request.js";
//引入权限控制
import "./assets/js/auth.js";
//引入表格样式
import tableStyle from "./assets/js/tableStyleData.js";
//引入压缩格式
import commonData from "./assets/js/commonData.js";
//引入页面整体组件
import fullCon from "./views/FullContainer";
import tableCon from "./views/tableContainer";
// import editCon from './views/editContainer'
import editBreadcrumb from "./views/layout/components/editBreadCrumb";
import modalDialog from "./components/ModalDialog/index";
Vue.component("full-con", fullCon);
Vue.component("table-con", tableCon);
// Vue.component('edit-con',editCon)
Vue.component("editBreadcrumb", editBreadcrumb);

Vue.component("tree-table", TreeTable);
Vue.component("v-distpicker", VDistpicker);
Vue.use(VueQuillEditor);
Vue.prototype.tableStyle = tableStyle;
Vue.prototype.commonData = commonData;
Vue.prototype._ = lodash;

//防抖
const on = Vue.prototype.$on;
Vue.prototype.$on = function (event, func) {
    let timer;
    let flag = true;
    let newFunc = func;
    if (event == "click") {
        newFunc = function () {
            if (flag) {
                func.apply(this, arguments);
                flag = false;
            }
            clearTimeout(timer);
            timer = setTimeout(function () {
                flag = true;
            }, 500);
        };
    }
    on.call(this, event, newFunc);
};

Vue.config.productionTip = false;

Vue.use(ElementUI, {
    size: 'default',
    i18n: (key, value) => i18n.t(key, value)
})

Vue.use(modalDialog, { router, store, i18n });

new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
